import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  encounterAudio: null,
  uploadAudioResponse: null,
  fileNameResponse: [],
};

const audioSlice = createSlice({
  name: 'audio',
  initialState: initialState,
  reducers: {
    getEncounterAudioSlice: (state, action) => {
      state.encounterAudio = action.payload;
    },
    uploadAudioSlice: (state, action) => {
      state.uploadAudioResponse = action.payload;
    },
    getFileNameSlice: (state, action) => {
      state.fileNameResponse = action.payload;
    },
  },
});

export const { actions, reducer } = audioSlice;

export const { getEncounterAudioSlice, uploadAudioSlice, getFileNameSlice } =
  actions;

export default reducer;
